module.exports = __webpack_public_path__ + "img/elderlyFile.f0ab2e27.svg";